import { navigate } from "gatsby";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

interface CategoryRedirectProps {
  pageContext: {
    redirectTo: string;
    pageType: string;
  };
}

const CategoryRedirect = ({ pageContext }: CategoryRedirectProps) => {
  const redirectTo = pageContext.redirectTo;

  useEffect(() => {
    navigate(redirectTo, { replace: true });
  }, [redirectTo]);

  return (
    <Helmet>
      <meta httpEquiv="refresh" content={`0;url=${redirectTo}`} />
    </Helmet>
  );
};

export default CategoryRedirect;
